import type { ComponentProps } from "react";
import { LuBookmark, LuImage, LuLayers, LuMusic } from "react-icons/lu";

const iconByType = {
  bookmark: LuBookmark,
  playlist: LuMusic,
  gallery: LuImage,
  collection: LuLayers,
};

type CollectionIconProps = ComponentProps<typeof LuLayers> & {
  type?: keyof typeof iconByType;
};

export const CollectionIcon = ({
  type = "collection",
  ...props
}: CollectionIconProps) => {
  const Icon = iconByType[type] || LuLayers;
  return <Icon {...props} />;
};
